module.exports = __webpack_public_path__ + "static/gamer-9f9117821f9f15d30413181e434a9672.png";